import { getFromSdk } from './utils';
// REGISTRATION
export const registerUser = async () => {
    const sdk = await getFromSdk();
    return sdk.register(); // user will be asked to give notifications permission
};
export const canRegister = () => {
    return getFromSdk('canRegister');
};
export const getChannelId = () => {
    return getFromSdk('channel.id');
};
export const getChannelTags = () => {
    return getFromSdk('channel.tags');
};
export const getChannelTagsList = () => {
    return getFromSdk('channel.tags.list', {});
};
export const getChannel = () => {
    return getFromSdk('channel');
};
export const getIsSupported = () => {
    return getFromSdk('isSupported');
};
export const getPermission = () => {
    return getFromSdk('permission');
};
export const getSdk = () => {
    return getFromSdk();
};
// OPT IN/OUT
export const getIsOptedIn = () => getFromSdk('channel.optedIn');
export const optOut = async () => {
    const notificationsOptOut = await getFromSdk('channel.optOut');
    return !notificationsOptOut ? null : notificationsOptOut();
};
//# sourceMappingURL=api.js.map